const puzzle = {
  id: "4R0cQVRRgXaEElxyVHMT",
  name: "No Names But All The Credit",
  rebuses: [
    {
      style: {},
      clues: [
        {
          dependsOn: [],
          helperText:
            "Rapper (born July 6, 1975), singer (born April 13, 1982) and actor (born December 19, 1897)",
          id: "ef978790-d2ef-4cab-90d6-8ef381ad1432",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "1a341249-1076-4f3a-8858-2f9a8aa27e02",
                value: "Nickel",
              },
            ],
            solvedText: "Nickel",
            type: "text",
          },
          clueValues: [
            {
              id: "1f714f5b-c372-4b66-911c-b9011bb00b29",
              subtext: "",
              value: "Y3hdH8rq.png",
              style: {
                width: "calc(30% - 10px)",
              },
              type: "image",
            },
            {
              id: "d0052ef3-c019-4e41-ad4c-40dd29acac96",
              value: "*",
              subtext: "",
              style: {
                width: "calc(10% - 10px)",
              },
              type: "text",
            },
            {
              value: "2",
              id: "ed93ebed-bf89-4254-bec0-376601506b7c",
              style: {
                width: "calc(10% - 10px)",
              },
              subtext: "",
              type: "text",
            },
            {
              type: "text",
              subtext: "",
              value: "=",
              id: "300965b0-645b-45b4-9ebc-34cda081a7cb",
              style: {
                width: "calc(10% - 10px)",
              },
            },
            {
              style: {
                width: "calc(30% - 10px)",
              },
              subtext: "",
              value: "iYxOm54B.png",
              id: "ebc03d96-6ffe-439b-b297-f2b9dcacff3a",
              type: "image",
            },
            {
              value: "Y3hdH8rq.png",
              style: {
                width: "calc(30% - 10px)",
              },
              type: "image",
              id: "3196ccec-95e5-47ed-95a5-cc9a84daac98",
              subtext: "",
            },
            {
              value: "/",
              style: {
                width: "calc(10% - 10px)",
              },
              subtext: "",
              type: "text",
              id: "e9136d31-46f6-4205-9bc7-cd4cc1b1e05d",
            },
            {
              style: {
                width: "calc(30% - 10px)",
              },
              value: "t9ulKU8D.png",
              type: "image",
              subtext: "",
              id: "7073eb7b-0bf7-46fe-91ff-a188f81b1a15",
            },
            {
              style: {
                width: "calc(10% - 10px)",
              },
              type: "text",
              subtext: "",
              value: "=",
              id: "f686c821-28e6-4ba0-999c-250ab8e29a74",
            },
            {
              id: "5e88d22e-4e9a-4c96-bc4b-c1d187366928",
              subtext: "",
              value: "X",
              style: {
                width: "calc(10% - 10px)",
              },
              type: "text",
            },
          ],
          clueGroup: 0,
          style: {
            width: "calc(50% - 10px)",
          },
          subtext: "x = _____",
        },
        {
          clueGroup: 0,
          solutionInfo: {
            solvedText: "Back",
            type: "text",
            possibleSolutions: [
              {
                value: "Back",
                id: "f266a991-ad12-48c1-91f1-7cdf3b1a0136",
              },
            ],
          },
          clueValues: [
            {
              style: {
                width: "calc(50% - 10px)",
              },
              type: "image",
              subtext: "",
              value: "3U80hMbw.png",
              id: "9db337be-c32a-4852-9dc3-a9b162cb0a0b",
            },
            {
              id: "a9e269af-0fca-401d-8e9a-83babc6ceb8d",
              type: "image",
              subtext: "",
              style: {
                width: "calc(50% - 10px)",
              },
              value: "2JQiGFD1.png",
            },
          ],
          id: "195a7180-995f-4233-9107-c752663b887c",
          dependsOn: [],
          helperText:
            "What word do this part of a body and going to one point and then returning have in common?",
          style: {
            width: "calc(50% - 10px)",
          },
          subtext: "",
        },
        {
          dependsOn: [
            {
              id: "d7d41fd2-bcf3-46ce-b214-387c8cec8c36",
              value: "ef978790-d2ef-4cab-90d6-8ef381ad1432",
            },
            {
              value: "195a7180-995f-4233-9107-c752663b887c",
              id: "4dc01ce1-de16-487d-b87d-f525d204e1f5",
            },
          ],
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          clueGroup: 0,
          style: {
            width: "calc(100% - 10px)",
          },
          subtext: "",
          id: "6b77f73a-c5de-4b4a-a09b-88b1e59f6633",
          clueValues: [
            {
              subtext: "Every time he sees it it makes him laugh",
              value: "Nickleback",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
              id: "5a90c043-7dc6-453c-9de9-5576a2a47c39",
            },
          ],
          helperText: "",
        },
      ],
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "cd25c29c-ca39-4464-8e96-38867f06f3d3",
            value: "Photograph",
          },
        ],
        solvedText: "Photograph",
      },
      id: "88fc21fd-7583-46fb-be17-734c4599983f",
    },
    {
      clues: [
        {
          id: "dbfa2d3e-b6c4-412d-8060-d36a913c0076",
          solutionInfo: {
            type: "text",
            solvedText: "",
            possibleSolutions: [],
          },
          clueGroup: 0,
          style: {
            width: "calc(100% - 10px)",
          },
          subtext: "",
          helperText:
            "Find a last name of a family in picture. There is a center in New York named after one of these people.",
          clueValues: [
            {
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "8cMqPjmr.png",
              id: "d59af721-6d68-4715-bf05-ed3c2f285b97",
              type: "image",
            },
          ],
          dependsOn: [],
        },
      ],
      solutionInfo: {
        solvedText: "Rockefeller",
        possibleSolutions: [
          {
            id: "06867ff7-9941-46f5-81cf-daa73ba179f8",
            value: "Rockefeller",
          },
        ],
        type: "text",
      },
      style: {},
      id: "6df16f6f-63c3-4be2-b998-5b8e059836ec",
    },
    {
      solutionInfo: {
        possibleSolutions: [
          {
            id: "c8b2f07a-2e86-4582-bc51-ece327ea970a",
            value: {
              minute: "",
              hour: "",
              place: "",
              second: "",
              year: "1932",
              day: "",
              month: "",
            },
          },
        ],
        solvedText: "1932.",
        type: "date",
      },
      clues: [
        {
          subtext: "",
          solutionInfo: {
            type: "text",
            solvedText: "",
            possibleSolutions: [],
          },
          style: {
            width: "calc(43% - 10px)",
          },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              subtext: "",
              id: "192cb1d1-c71d-426d-8391-077ef109485d",
              type: "customComponent",
              value: "_1932VennDiagram",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          id: "37b878a1-a2a0-4471-8b40-770f3f61af0a",
          helperText: "What year do these Nobel prize winners have in common?",
        },
      ],
      id: "3bb2c826-6408-4fe6-92a6-799ac5704266",
      style: {},
    },
    {
      id: "893a6f34-b9d8-432e-a7e0-383d46a7f835",
      solutionInfo: {
        type: "text",
        solvedText: "Lunch Atop A Skyscraper",
        possibleSolutions: [
          {
            id: "7452ba44-e8fe-42f7-9897-2e4774d65570",
            value: "Lunch Atop A Skyscraper",
          },
        ],
      },
      clues: [
        {
          style: {
            width: "calc(33% - 10px)",
          },
          subtext: "",
          helperText: "",
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          id: "8a6e9286-5c2e-495a-bd8b-7ff29bf9a8b8",
          clueGroup: 1,
          clueValues: [
            {
              subtext: "",
              id: "f58c4ad0-37f6-4136-b974-f8fb50e6c850",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
              value: "Photograph",
            },
          ],
          dependsOn: [],
        },
        {
          subtext: "",
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
          id: "f68188d5-759b-447f-a37e-4a90440f56f1",
          helperText: "",
          clueGroup: 1,
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              id: "77680139-026f-4b29-a1b2-917c3d8a1996",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
              value: "Rockefeller",
              subtext: "",
            },
          ],
        },
        {
          id: "f263a8b5-7f65-483f-af26-aa877dffacba",
          subtext: "",
          helperText: "",
          clueGroup: 1,
          dependsOn: [],
          clueValues: [
            {
              id: "af5b2964-6cde-4107-a1af-8b37d809fce5",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
              value: "1932.",
              subtext: "",
            },
          ],
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          style: {
            width: "calc(33% - 10px)",
          },
        },
      ],
      style: {},
    },
  ],
};

export default puzzle;
